import { createAsyncThunk } from "infrastructure/store/lib";
import type { AsyncThunk, RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import { payloadCreator } from "util/api";
import { concat } from "util/support";
import { getMerchants, createOrUpdateMerchant } from "features/merchants/api";
import { sliceToken } from "./state";
import type { Merchant, MerchantsResponse } from "./types";

export const getMerchantsThunk: AsyncThunk<
    ThunkReturnType<MerchantsResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.GetMerchants]),
    payloadCreator(getMerchants),
    {
        condition: (_, { getState }) => {
            const { merchants } = getState() as RootState;

            return ![ApiState.Pending].includes(merchants.merchantsLoadingState);
        }
    }
);

export const postMerchantThunk: AsyncThunk<any, Partial<Merchant>, {}> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.PostMerchant]),
    payloadCreator(createOrUpdateMerchant),
    {
        condition: (_, { getState }) => {
            const { merchants } = getState() as RootState;
            return ![ApiState.Pending].includes(merchants.merchantProfileLoadingState);
        }
    }
);
